import { CardContent, Divider } from "@mui/material";
import { AboutIcon, Card, Grid, Spacer, Typography } from "../style";
import { Email, Phone, PhoneAndroid } from "@mui/icons-material";

function Contatti({ contatti }) {
  const email = contatti?.filter(
    (c) => c.idTipologia === 3 && c.predefinito === 1
  );
  const cellulare = contatti?.filter(
    (c) => c.idTipologia === 1 && c.predefinito === 1
  );
  const telefono = contatti?.filter(
    (c) => c.idTipologia === 2 && c.predefinito === 1
  );
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Contatti
        </Typography>

        <Spacer mb={4} />

        <Grid container direction="row" alignItems="center" mb={2}>
          <Grid item>
            <AboutIcon>
              <Email />
            </AboutIcon>
          </Grid>
          <Grid item>{email?.[0]?.valore}</Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2}>
          <Grid item>
            <AboutIcon>
              <PhoneAndroid />
            </AboutIcon>
          </Grid>
          <Grid item>{cellulare?.[0]?.valore}</Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2}>
          <Grid item>
            <AboutIcon>
              <Phone />
            </AboutIcon>
          </Grid>
          <Grid item>{telefono?.[0]?.valore}</Grid>
        </Grid>
      </CardContent>
      <Divider />
    </Card>
  );
}

export default Contatti;
